<ol class="breadcrumb" style="margin-bottom: 0px;">
    <li *ngFor="let breadcrumb of breadcrums; let last = last"  [ngClass]="breadcrumb.className">
       
        <a   [routerLink]="[breadcrumb.url]" *ngIf="!last">{{ breadcrumb.label }}&nbsp;</a><span class="breadcrumbsName"  *ngIf="last">{{ breadcrumb.label}}</span>

            
        
    </li>
</ol>